module.exports = "<div class=\"gw-wizard-main\">\n    <div class=\"gw-page gw-box\">\n        <div class=\"gw-wizard-progress\" gw-wizard-step-progress></div>\n        <div ng-transclude></div>\n    </div>\n    <div class=\"gw-preventActionsLayer\" ng-class=\"{'gw-locked': sidebarMenuVisible()}\"\n         ng-click=\"hideSidebarMenu()\"></div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/wizard/templates/wizard-content.html
 ** module id = 729
 ** module chunks = 0
 **/